export const TABS = [
    { label: 'Today', value: 1, profitChartLabel: 'Today profit' },
    { label: '7 days', value: 7, profitChartLabel: '7 day profit' },
    { label: '30 days', value: 30, profitChartLabel: '30 day profit' },
];
